export const common = {
  white: "#FFFFFF",
  black: "#000000",
  chipBackground: "linear-gradient(111.56deg, #DCD6FF 7.52%, #BE05DC 93.81%)",
  lightAmaranth: "#FFDDE0",
  amaranth: "#DF4957",
  buttonColor: "#F7631F",
  darkGrey: "#28374C",
  lightGrey: "#486284",
  footerBackground: "#fff6f3",
  lightText: "#DDDDDD",
  mediumText: "#AAB5C3",
  naradLightBg: "#FAF4F1",
};

export const primaryColor = {
  100: "#FDEEE9",
  200: "#FBDDD2",
  300: "#F8CCBC",
  400: "#F6BBA6",
  500: "#F4AA90",
  600: "#F29875",
  700: "#F08762",
  800: "#EB6539",
  900: "#E95420",
};

export const secondaryLightColor = {
  300: "#F5F7FF",
  400: "#E8EBF5",
  500: "#C0C5D8",
  600: "#949BB6",
  700: "#6B738E",
  800: "#4B5372",
  900: "#1F2744",
};

export const secondaryDarkColor = {
  100: "#F9FAFC",
  200: "#DCDFE9",
  300: "#B6BCCD",
  400: "#898FA3",
  500: "#62687A",
  600: "#454A5A",
  700: "#2D323F",
  800: "#1A1D26",
  900: "#101218",
};

export const transparentBgColor = {
  500: "#ffdfd5",
};

export const LIGHT = {
  designationColor: {
    Dev: "#323232",
    Des: "linear-gradient(111.56deg, #DCD6FF 7.52%, #BE05DC 93.81%)",
    Tes: "#FFEDD6",
  },
  primary: {
    main: "#F7631F",
    light: primaryColor[400],
    dark: "#D14B21",
    contrastText: common.white,
  },
  secondary: {
    main: secondaryDarkColor[600],
    light: secondaryLightColor[300],
    dark: "#08090E",
    contrastText: secondaryLightColor[800],
  },
  text: {
    primary: common.black,
    secondary: secondaryDarkColor[600],
    title: secondaryLightColor[800],
    title1: secondaryLightColor[900],
    subtitle: secondaryLightColor[900],
    subtitle2: secondaryLightColor[600],
    subtitle3: secondaryLightColor[800],
    dropdown: secondaryLightColor[700],
    subText: secondaryLightColor[700],
    domainText: secondaryLightColor[700],
    userName: secondaryDarkColor[700],
    date: secondaryDarkColor[700],
    time: secondaryDarkColor[800],
    tableText: secondaryDarkColor[600],
    cancel: secondaryDarkColor[600],
    edit: secondaryLightColor[600],
    calendar: secondaryLightColor[700],
    listSubText: secondaryLightColor[700],
    copyrightText: secondaryLightColor[800],
    signInTitle: secondaryLightColor[900],
    selectIcon: secondaryLightColor[600],
    disabled: secondaryLightColor[500],
  },
  divider: secondaryDarkColor[200],
  icon: secondaryLightColor[500],
  background: {
    default: secondaryDarkColor[100],
    paper: common.white,
    border: secondaryLightColor[400],
    tableRow: secondaryDarkColor[100],
    button: common.white,
    active: secondaryLightColor[400],
    select: secondaryLightColor[300],
    id: "#FFEDD6",
    missing: "#FFEFEA",
    new: "#FFF7EC",
    deleteBorder: "#EE3B4C26",
    infoBorder: secondaryLightColor[400],
    shadow: "#dee2e666",
    transparent: transparentBgColor[500],
    empCard: primaryColor[200],
    tableIconButton: secondaryLightColor[400],
    edit: secondaryLightColor[600],
    backdrop: "#00000026",
    pending: " #FFF9E2",
  },
  tableBorder: secondaryLightColor[400],
  designationBackground: {
    purple: "#F5EEFF",
    blue: "#EFF1FF",
    red: "#FFF3F4",
    orange: "#FFEFEA",
  },
  success: {
    main: "#11BB69",
  },
  error: {
    main: "#EE3B4C",
  },
  warning: {
    main: "#F4C622",
  },
  info: {
    main: "#4A6CFD",
  },
  altColor: {
    purple: "#8C48E5",
    green: "#11BB69",
    blue: "#0092BB",
    indigo: "#476BE5",
    red: "#DF4957",
    cyan: "#4AB5B0",
    yellow: "#EEDD44",
    orange: "#FF9F1C",
    nightRider: "#323232",
  },
  devChipBg: "#323232",
  primaryColor,
  common,
  secondaryColor: secondaryDarkColor,
  secondaryLightColor,
  secondaryDarkColor,
  type: "Light",
};
